<app-header></app-header>
<div class="container-fluid" style="min-height:87vh">

  <div class="alert alert-info" role="alert" style="margin: 20px 0;">
    <strong>ℹ️ You're using our new validation system!</strong>
    <br>
    Experiencing issues? Switch to the legacy system:
    <a [routerLink]="['/validation_legacy/samples']" class="alert-link" style="margin-left: 8px;">Samples</a> |
    <a [routerLink]="['/validation_legacy/experiments']" class="alert-link" style="margin-left: 8px;">Experiments</a> |
    <a [routerLink]="['/validation_legacy/analyses']" class="alert-link" style="margin-left: 8px;">Analysis</a>
  </div>

  <!-- Dash App iframe -->
  <div class="beta-frame-wrapper">
    <iframe
      class="beta-frame"
      [src]="betaUrl"
      title="FAANG Validator"
      loading="lazy"
    ></iframe>
  </div>

</div>
